import { RouteObject, Navigate } from 'react-router-dom';
import { InventoryRoutes } from './modules/inventory';
import { WarehouseRoutes } from './modules/warehouse';
import { PurchasingRoutes } from './modules/purchasing';
import { ProcurementRoutes } from './modules/procurement';
import { ManufacturingRoutes } from './modules/manufacturing';
import { FulfillmentRoutes } from './modules/fulfillment';
import { FieldserviceRoutes } from './modules/fieldservice';
import { DemandRoutes } from './modules/demand';
import { ReverseRoutes } from './modules/reverse';

export const operationsRoutes: RouteObject[] = [
  { path: '', element: <Navigate to="inventory/stock-levels" replace /> },

  // Modular Feature Routes
  InventoryRoutes,
  WarehouseRoutes,
  PurchasingRoutes,
  ProcurementRoutes,
  ManufacturingRoutes,
  FulfillmentRoutes,
  FieldserviceRoutes,
  DemandRoutes,
  ReverseRoutes,

  // Legacy Route Redirects
  { path: 'products', element: <Navigate to="inventory/sku-master" replace /> },
  { path: 'stock-levels', element: <Navigate to="inventory/stock-levels" replace /> },
  { path: 'alerts', element: <Navigate to="inventory/reorder-alerts" replace /> },
  { path: 'warehouses', element: <Navigate to="warehouse/locations" replace /> },
  { path: 'transfers', element: <Navigate to="warehouse/transfers" replace /> },
  { path: 'batches', element: <Navigate to="warehouse/batches-serials" replace /> },

  { path: 'purchase-orders', element: <Navigate to="purchasing/purchase-orders" replace /> },
  { path: 'suppliers', element: <Navigate to="purchasing/suppliers" replace /> },
  { path: 'sourcing-rules', element: <Navigate to="purchasing/sourcing-rules" replace /> },
  { path: 'goods-receipts', element: <Navigate to="purchasing/goods-receipts" replace /> },
  { path: 'qa-inspections', element: <Navigate to="purchasing/qa-inspections" replace /> },

  { path: 'sales-orders', element: <Navigate to="fulfillment/sales-orders" replace /> },
  { path: 'allocations', element: <Navigate to="fulfillment/allocations" replace /> },
  { path: 'pick-pack-ship', element: <Navigate to="fulfillment/pick-pack-ship" replace /> },
  { path: 'shipments', element: <Navigate to="fulfillment/carrier-tracking" replace /> },
  { path: 'tracking', element: <Navigate to="fulfillment/carrier-tracking" replace /> },
  { path: 'shipping-labels', element: <Navigate to="fulfillment/shipping-labels" replace /> },

  { path: 'bom', element: <Navigate to="manufacturing/boms" replace /> },
  { path: 'work-orders', element: <Navigate to="manufacturing/work-orders" replace /> },
  { path: 'yield-scrap', element: <Navigate to="manufacturing/yield-scrap" replace /> },
  { path: 'forecasting', element: <Navigate to="demand/forecasting" replace /> },
  { path: 'reorder-recommendations', element: <Navigate to="demand/safety-stock" replace /> },

  { path: 'service-orders', element: <Navigate to="fieldservice/service-orders" replace /> },
  { path: 'technician-schedule', element: <Navigate to="fieldservice/technician-scheduling" replace /> },
  { path: 'mobile-dispatch', element: <Navigate to="fieldservice/mobile-field-app" replace /> },
  { path: 'supplier-scorecards', element: <Navigate to="procurement/supplier-scorecards" replace /> },
  { path: 'quality-metrics', element: <Navigate to="procurement/spend-analytics" replace /> },
];
